import React, { FC } from 'react';
import styled from 'styled-components';
import { renderFont } from '@empiriecom/module-components/ThemeProvider';
import {
  AttributeValue,
  OOCVAttributeValue,
  OOCVAttributeValueObject,
  OOCVAttributeValues,
} from '@/src/interfaces';

const TableBlock = styled.div`
  margin-top: 0.75rem;
`;

const TableHeader = styled.div`
  font-size: 0.938rem;
  padding: 0.375rem 0.688rem 0.5rem 0.813rem;
  background-color: ${({ theme }) => theme.greyLight.color.normal};
  width: 100%;
`;

const TableRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
`;

const KeyTableCell = styled.div`
  ${({ theme }) => renderFont('base', 'bold', theme)};
  font-size: 0.813rem;
  width: 50%;
  box-shadow: ${({ theme }) =>
    `inset -1px -1px 0 0 ${theme.greyLight.color.normal}, inset 1px 0 0 0 ${theme.greyLight.color.normal}`};
  padding: 0.375rem 0.688rem 0.5rem 0.813rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const ValuesTableCell = styled.div`
  font-size: 0.813rem;
  width: 50%;
  box-shadow: ${({ theme }) => `inset -1px -1px 0 0 ${theme.greyLight.color.normal}`};
  padding: 0.375rem 0.688rem 0.5rem 0.813rem;
`;

const OOCVTableBlock: FC<{ value: OOCVAttributeValues }> = ({ value }) => (
  <TableBlock>
    <TableHeader>{value.blockName}</TableHeader>
    {value.values.map((oocvValue: OOCVAttributeValue, index) => (
      <TableRow key={oocvValue.key.concat(index.toFixed())}>
        <KeyTableCell>{oocvValue.key}</KeyTableCell>
        <ValuesTableCell>
          {oocvValue.values.map((oocvVal, idx) => (
            <div
              key={oocvVal.concat(idx.toFixed())}
              // oocv values can contain HTML
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: oocvVal,
              }}
            />
          ))}
        </ValuesTableCell>
      </TableRow>
    ))}
  </TableBlock>
);

/**
 * This is the oocv table component. It renders the oocv table within the product details for the provided values.
 */
export const OOCVTable: FC<{ values: AttributeValue[] }> = ({ values }) => (
  <div data-testid="oocv-table-wrapper">
    {(values[0] as OOCVAttributeValueObject).data.map((value, index: number) => (
      <OOCVTableBlock key={value.blockName.concat(index.toFixed())} value={value} />
    ))}
  </div>
);

export default OOCVTable;
